import { Player, useGameContext } from "GameContext";

import {
  useState,
  useEffect,
} from "react";
import ReedHarvester from "components/Player/RoleTab/ReedHarvester";
import Stockbreeder from "components/Player/RoleTab/Stockbreeder";
import NGO from "components/Player/RoleTab/NGO";
import PrivateHunter from "components/Player/RoleTab/PrivateHunter";
import PublicHunter from "components/Player/RoleTab/PublicHunter";

export default function RoleInfo({
  onInfoClick=()=>null,
  playerInfo,
} : {
    onInfoClick?: () => void,
    playerInfo:Player,
}) {
  const [showContacts, setShowContacts] = useState(true);
  const [roomId, setRoomId] = useState("");

  function renderRoleTab() {
    // Adjust logic to match your real role/estate strings
    switch (playerInfo.role) {
      case "Reed Harvester":
        return <ReedHarvester/>; // no info or callbacks
      case "Stockbreeder":
        return <Stockbreeder/>; // this will need button callbacks and info
      case "Conservationist":
        return <NGO/>; // needs info for the data
      case "Hunter":
        if (playerInfo?.estate === "public") {
          return <PublicHunter/>
        }
        return <PrivateHunter/>; // needs info for some stuff
      default:
        return null;
    }
  }

  return (
    <div className="flex flex-col p-2 overflow-y-auto">
      <p>{playerInfo.role}</p>
      <button className="absolute top-2 right-2" onClick={() => onInfoClick()}>x</button>
      {renderRoleTab()}
    </div>
  )

}
